import React from 'react';
import {
  constructOriginatorMapLink,
  constructMapLinkLabel,
} from 'modules/map/mapUtils';
import { Originator, OriginatorBody, OriginatorRelation } from 'types';
import {
  RegisterSection,
  RegisterSectionField,
  // RegisterRelationDetail,
} from './register-section';
import { isOriginatorBodyEmpty } from './utils';
import { constructRelationLink } from './utils/construct-originator-labels';
import { createStyles, makeStyles } from '@material-ui/core';

type Props = {
  body?: OriginatorBody;
  bodyRelations: OriginatorRelation[];
  originatorDetail: Originator;
};

const plainTextFields: { key: keyof OriginatorBody; label: string }[] = [
  { key: 'briefDescription', label: 'Stručná charakteristika' },
  { key: 'corpPurpose', label: 'Funkce korporace' },
  { key: 'corpStructure', label: 'Vnitřní struktury korporace' },
  { key: 'foundingNorms', label: 'Normy - konstitutivní' },
  { key: 'scopeNorms', label: 'Normy - působnost korporace' },
  { key: 'geoObjectTypeLabel', label: 'Typ geografického objektu' },
  { key: 'sourceInfo', label: 'Zdroje informací' },
  { key: 'biography', label: 'Životopis' },
  { key: 'history', label: 'Dějiny' },
  { key: 'address', label: 'Adresní místo' },
  { key: 'note', label: 'Poznámka' },
];

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      color: '#000',
      fontWeight: 'normal',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  })
);

export default function RegisterDetailBodySection(props: Props) {
  const { body, originatorDetail, bodyRelations } = props;
  const classes = useStyles();
  return (
    <RegisterSection title="Tělo">
      <div style={{ paddingLeft: 8, paddingBottom: 16 }}>
        {isOriginatorBodyEmpty(body) ? (
          <span style={{ fontWeight: 400 }}>
            Sekce neobsahuje žádné informace
          </span>
        ) : (
          <>
            {plainTextFields.map((field) => (
              <RegisterSectionField
                key={field.key}
                label={field.label}
                value={body?.[field.key]}
                plainText
              />
            ))}

            {body?.coordPoint && (
              <RegisterSectionField
                label="Definiční bod"
                plainText
                value={
                  <a
                    className={classes.link}
                    target="_blank"
                    href={
                      process.env.PUBLIC_URL +
                      constructOriginatorMapLink(originatorDetail.id, 0)
                    }
                    rel="noreferrer"
                  >
                    {(() => {
                      const { labelPrefix, linkLabel } = constructMapLinkLabel(
                        body?.coordPoint ?? ''
                      );
                      return `${labelPrefix}${linkLabel}`;
                    })()}
                  </a>
                }
              />
            )}
            {(body?.sourceLinks ?? []).map((sl) => (
              <RegisterSectionField
                key={sl.id}
                label="Odkaz na zdroje informací"
                value={sl?.name || decodeURIComponent(sl.url)}
                directLink={sl.url}
                externLink
              />
            ))}
            {body?.coordBorder && (
              <RegisterSectionField
                label="Hranice"
                plainText
                value={
                  <a
                    className={classes.link}
                    target="_blank"
                    href={
                      process.env.PUBLIC_URL +
                      constructOriginatorMapLink(originatorDetail.id, 1)
                    }
                    rel="noreferrer"
                  >
                    {(() => {
                      const { labelPrefix, linkLabel } = constructMapLinkLabel(
                        body?.coordBorder ?? ''
                      );
                      return `${labelPrefix}${linkLabel}`;
                    })()}
                  </a>
                }
              />
            )}

            {(bodyRelations ?? [])
              .filter((r) => r.relatedEntity.resolved)
              .map((r, index) => (
                <RegisterSectionField
                  key={`rsection-body-${index}`}
                  label={r.typeLabel}
                  value={r.relatedEntity.label}
                  directLink={constructRelationLink(r.relatedEntity)}
                />
              ))}
          </>
        )}
      </div>
    </RegisterSection>
  );
}
